import "../legacy"

import "../stylesheets/application.css.sass"

require.context("../images")

import "cookie-consent"
